module.exports = __webpack_public_path__ + "img/beer_id-103.004845cc.png";